import { Component } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { FortigatesService } from '@app/features/fortigates/shared/fortigates.service';

@Component({
    selector: 'app-site-ip-info',
    templateUrl: './site-ip-info.component.html',
    styleUrls: ['./site-ip-info.component.scss'],
    standalone: false
})
export class SiteIpInfoComponent {

  storeNumber: string = '';
  lanInfo: Record<string, string> | null = null;
  lanError: string | null = null;
  wanInfo: Record<string, string> | null = null;
  wanError: string | null = null;
  loading: boolean = false;

  constructor(private fortigatesService: FortigatesService) { }

  async getItems() {
    this.loading = true;
    // LAN (DNS) and WAN1 (source of truth) are pulled independently so a store
    // missing from one source still shows what the other has.
    const [lanResult, wanResult] = await Promise.all([
      this.fetchFields(() => this.fortigatesService.getLanFields(this.storeNumber)),
      this.fetchFields(() => this.fortigatesService.getWanFields(this.storeNumber)),
    ]);
    this.lanInfo = lanResult.fields;
    this.lanError = lanResult.error;
    this.wanInfo = wanResult.fields;
    this.wanError = wanResult.error;
    this.loading = false;
  }

  private async fetchFields(call: () => Promise<any>): Promise<{ fields: Record<string, string> | null, error: string | null }> {
    try {
      const response: any = await firstValueFrom(await call());
      if (response.status != 200) {
        return { fields: null, error: this.extractErrorMessage(response) };
      }
      return { fields: response.body?.message ?? {}, error: null };
    } catch (error: any) {
      console.log(error);
      return { fields: null, error: this.extractErrorMessage(error) };
    }
  }

  private extractErrorMessage(response: any): string {
    return response?.error?.message
      ?? response?.body?.message
      ?? response?.message
      ?? "Unknown error";
  }

}
